<template>
  <span>
    <div class="mt-2">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form class="" @submit.prevent="handleSubmit(paymentClicked)">
          <div v-if="isStripeLoaded">
            <stripe-element-card
              ref="elementRef"
              :pk="publicKey"
              :hidePostalCode="postalCode"
              @token="tokenCreated"
            />
          </div>
          <div v-else>Loading Stripe...</div>
          <div class="row">
            <div class="col-md-12">
              <label class="form-control-label">Billing Address <span class="requireField">*</span></label>
              <base-input
                type="text"
                name="address"
                placeholder="Address"
                rules="required"
                v-model="Address.address"
              >
              </base-input>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">City <span class="requireField">*</span></label>
              <base-input
                type="text"
                name="city"
                placeholder="City"
                rules="required"
                v-model="Address.city"
              >
              </base-input>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">State <span class="requireField">*</span></label>
              <base-input
                type="text"
                name="state"
                placeholder="State"
                rules="required"
                v-model="Address.state"
              >
              </base-input>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Zipcode <span class="requireField">*</span></label>
              <base-input
                type="text"
                name="zipcode"
                placeholder="Zipcode"
                rules="required"
                v-model="Address.zipcode"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-2">
              <b style="color:#13569a">Actual Amount:</b>
              {{ formatPrice(orignalAmount) }}
            </div>
            <div class="col-12 mb-2">
              <b style="color:#13569a">Amount Payable: </b>
              <span>{{ formatPrice(amountPayable) }}
                <span>({{ discount }}% Off)</span>
              </span>
            </div>
          </div>
          <div class="text-right">
            <base-button type="primary" native-type="submit" :disabled="!isStripeLoaded">Pay</base-button>
          </div>
        </form>
      </validation-observer>
    </div>
    <div class="row mt-4 justify-content-between align-items-right">
      <div class="col text-right">
        <img
          width="100px"
          src="img/icons/cards/pci-dss-logo.png"
          alt="Image placeholder"
        />
      </div>
    </div>
  </span>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';

export default {
  name: "pay-purchase-course",
  components: {
    StripeElementCard,
  },
  props: {
    type: String,
    amountPayable: Number,
    orignalAmount: Number,
    discount: String,
    address: String,
    city: String,
    state: String,
    zipcode: String
  },
  data() {
    return {
      Address: {
        address: this.address || "",
        city: this.city || "",
        state: this.state || "",
        zipcode: this.zipcode || ""
      },
      card: {
        cardNumber: "",
        expire: "",
        token: null,
      },
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      postalCode: true,
      isStripeLoaded: false
    };
  },
  mounted() {
    this.loadStripe();
  },
  methods: {
    loadStripe() {
      if (window.Stripe) {
        this.isStripeLoaded = true;
      } else {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.onload = () => {
          this.isStripeLoaded = true;
        };
        document.head.appendChild(script);
      }
    },
    formatPrice(value) {
      return "$ " + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    },
    tokenCreated(token) {
      this.card.token = token;
      this.$emit("payClickedPurchase", this.card, this.Address);
    },
    paymentClicked() {
      if (this.$refs.elementRef) {
        this.$refs.elementRef.submit();
      } else {
        console.error('Stripe Element reference not found');
      }
    },
  }
};
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(87deg, #07c9fb 0, #ffffff 100%) !important;
}
</style>


